/**
 * @fileoverview DELETE handler for the "/companies/:company_id/custom_domains/:domain_type/:domain_id" endpoint
 */
import fetch from "@lib/fetch";

import { createMutationFetcherFunctionWithShadowError } from "../reactQueryFetcherAdapters/createMutationFetcherFunctionWithShadowError";
import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { deleteCompaniesCompanyIdCustomDomainsDomainTypeDomainIdCacheKeys } from "./constants";
import type {
  DeleteCompaniesCompanyIdCustomDomainsDomainTypeDomainIdProps,
  DeleteCompaniesCompanyIdCustomDomainsDomainTypeDomainIdResult,
  DeleteCompaniesCompanyIdCustomDomainsDomainTypeDomainIdResultErrors,
} from "./types";

export const deleteCompaniesCompanyIdCustomDomainsDomainTypeDomainId = reactQueryMutationAdapter(
  deleteCompaniesCompanyIdCustomDomainsDomainTypeDomainIdCacheKeys,
  createMutationFetcherFunctionWithShadowError<DeleteCompaniesCompanyIdCustomDomainsDomainTypeDomainIdResultErrors>()(
    ({
      companyId,
      domainType,
      domainId,
    }: DeleteCompaniesCompanyIdCustomDomainsDomainTypeDomainIdProps): Promise<DeleteCompaniesCompanyIdCustomDomainsDomainTypeDomainIdResult> => {
      return fetch(
        `/companies/${companyId}/custom_domains/${domainType}/${domainId}`,
        "DELETE",
        undefined,
        undefined,
        {
          // The deletion modal renders encoded errors inline.
          propagateFetchRequestError: false,
        }
      );
    }
  )
);
